import * as React from 'react';
import { postJson } from '@/lib/client-http';

export type SetupState =
  | { phase: 'idle' }
  | { phase: 'running' }
  | { phase: 'done'; prUrl: string }
  | { phase: 'error'; message: string };

export function useGovernSetup(
  orgId: string | undefined,
  projectId: string | undefined,
  repoFullName: string | undefined,
) {
  const [state, setState] = React.useState<SetupState>({ phase: 'idle' });

  const run = React.useCallback(async () => {
    if (!orgId || !projectId || !repoFullName) return;
    setState({ phase: 'running' });
    try {
      // No API key in the body: the route mints a per-binding scoped CLI
      // token server-side and writes that as the CI secret.
      const data = await postJson<{ pr: { url: string } }>(
        '/api/govern/setup',
        { orgId, projectId, repoFullName },
        'Setup failed',
      );
      const prUrl: string = data.pr.url;
      setState({ phase: 'done', prUrl });
    } catch (err) {
      setState({
        phase: 'error',
        message: err instanceof Error ? err.message : 'Network error',
      });
    }
  }, [orgId, projectId, repoFullName]);

  const reset = React.useCallback(() => {
    setState({ phase: 'idle' });
  }, []);

  return { state, run, reset };
}
